module.exports = __webpack_public_path__ + "static/media/a-infinitiv.6d81c0f2.mp3";